import React from "react";
import PropTypes from "prop-types";
import SectionsTitle from "../SectionTitle/SectionTitle";

const propTypes = {
  content: PropTypes.shape({}),
};

const LogoGridSection = ({ content }) => {
  return (
    <>
      <section className="bannerfour banner-wrapper m-t-20">
        <div className="container">
          <div className="text-center">
            <SectionsTitle
              title={content.logoGridColumns.title}
              subtitle={content.logoGridColumns.subTitle}
            />
          </div>
          {content.logoGridColumns.items.map((item, index) => {
            return (
              <div key={`item-${index + 1}`} className="row">
                {item.logos.map((logo) => {
                  return (
                    <div
                      key={logo.title}
                      className="col-md-2 bannerfourinner text-center box"
                    >
                      <img src={logo.icon} alt="icon" className="img-fluid" />
                      <p className="title">{logo.title}</p>
                    </div>
                  );
                })}
              </div>
            );
          })}
        </div>
      </section>
    </>
  );
};

const defaultProps = {};
LogoGridSection.propTypes = propTypes;
LogoGridSection.defaultProps = defaultProps;

export default LogoGridSection;
